import { SaihContext, SaihProposal, SaihSseEvent, SaihVocabulary } from '../models/saih.models';

export const SAIH_START_SESSION = '[SAIH] Start session';
export const SAIH_SEND_MESSAGE = '[SAIH] Send message';
export const SAIH_RECEIVE_SSE_EVENT = '[SAIH] Receive SSE event';
export const SAIH_ACCEPT_PROPOSAL = '[SAIH] Accept proposal';
export const SAIH_SEED_CONTEXT = '[SAIH] Seed context';
export const SAIH_SELECT_MODEL = '[SAIH] Select model';
export const SAIH_CLEAR_SESSION = '[SAIH] Clear session';
export const SAIH_SESSION_CREATION_STARTED = '[SAIH] Session creation started';
export const SAIH_SESSION_CREATION_FAILED = '[SAIH] Session creation failed';
export const SAIH_LOAD_VOCABULARY_STARTED = '[SAIH] Load vocabulary started';
export const SAIH_VOCABULARY_LOADED = '[SAIH] Vocabulary loaded';
export const SAIH_VOCABULARY_LOAD_FAILED = '[SAIH] Vocabulary load failed';

export class StartSession {
  static readonly type = SAIH_START_SESSION;
  constructor(public sessionId: string) {}
}

export class SessionCreationStarted {
  static readonly type = SAIH_SESSION_CREATION_STARTED;
}

export class SessionCreationFailed {
  static readonly type = SAIH_SESSION_CREATION_FAILED;
  constructor(public message?: string) {}
}

export class SendMessage {
  static readonly type = SAIH_SEND_MESSAGE;
  constructor(public message: string) {}
}

export class ReceiveSseEvent {
  static readonly type = SAIH_RECEIVE_SSE_EVENT;
  constructor(public event: SaihSseEvent) {}
}

export class AcceptProposal {
  static readonly type = SAIH_ACCEPT_PROPOSAL;
  constructor(public taskId?: string, public proposal?: SaihProposal) {}
}

export class SeedContext {
  static readonly type = SAIH_SEED_CONTEXT;
  constructor(public context: SaihContext | null) {}
}

export class SelectModel {
  static readonly type = SAIH_SELECT_MODEL;
  constructor(public model: string) {}
}

export class ClearSession {
  static readonly type = SAIH_CLEAR_SESSION;
}

export class LoadVocabularyStarted {
  static readonly type = SAIH_LOAD_VOCABULARY_STARTED;
}

export class VocabularyLoaded {
  static readonly type = SAIH_VOCABULARY_LOADED;
  constructor(public vocabulary: SaihVocabulary) {}
}

export class VocabularyLoadFailed {
  static readonly type = SAIH_VOCABULARY_LOAD_FAILED;
  constructor(public message?: string) {}
}
